"use strict";
module.exports = function(config, get){
	return {
		groupCount: handle_org_orggroup_count,
		patientCount: handle_org_patient_count,
		inactiveCount: handle_org_inactive_count,
		activeCount: handle_org_active_count,
		staffCount: handle_org_staff_count,
		managersCount: handle_org_managers_count,
		userCount: handle_org_user_count,
		group: {
			patientCount: handle_orggroup_patient_count,
			inactiveCount: handle_orggroup_inactive_count,
			activeCount: handle_orggroup_active_count,
			staffCount: handle_orggroup_staff_count,
			userCount: handle_orggroup_user_count,
		},
	};


	function handle_orggroup_patient_count(group){
		return get("/v2/org/stats/group/users/count/patients", {group});
	}
	function handle_orggroup_inactive_count(group){
		return get("/v2/org/stats/group/users/count/patients/inactive", {group});
	}
	function handle_orggroup_active_count(group){
		return get("/v2/org/stats/group/users/count/patients/active", {group});
	}
	function handle_orggroup_staff_count(group){
		return get("/v2/org/stats/group/users/count/staff", {group});
	}
	function handle_orggroup_user_count(group){
		return get("/v2/org/stats/group/users/count", {group});
	}
	function handle_org_orggroup_count(){
		return get("/v2/org/stats/group/count", {});
	}
	function handle_org_patient_count(){
		return get("/v2/org/stats/users/count/patients", {});
	}
	function handle_org_inactive_count(){
		return get("/v2/org/stats/users/count/patients/inactive", {});
	}
	function handle_org_active_count(){
		return get("/v2/org/stats/users/count/patients/active", {});
	}
	function handle_org_staff_count(){
		return get("/v2/org/stats/users/count/staff", {});
	}
	function handle_org_managers_count(){
		return get("/v2/org/stats/users/count/managers", {});
	}
	function handle_org_user_count(){
		return get("/v2/org/stats/users/count", {});
	}
};